
import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link, useNavigate } from 'react-router-dom';

interface HeaderWithBackButtonProps {
  title?: string;
  subtitle?: string;
  backTo?: string | number;
  backLabel?: string;
  children?: React.ReactNode;
}

const HeaderWithBackButton = ({
  title,
  subtitle,
  backTo = "/",
  backLabel = "Back to Home",
  children
}: HeaderWithBackButtonProps) => {
  const navigate = useNavigate();
  
  const handleBackClick = () => {
    if (typeof backTo === 'number') {
      navigate(backTo);
    }
  };
  
  return (
    <div className="mb-8 mt-6">
      {typeof backTo === 'string' ? (
        <Link to={backTo}>
          <Button variant="ghost" size="sm" className="gap-1 mb-4">
            <ArrowLeft className="h-4 w-4" />
            {backLabel}
          </Button>
        </Link>
      ) : (
        <Button 
          variant="ghost" 
          size="sm" 
          className="gap-1 mb-4"
          onClick={handleBackClick}
        >
          <ArrowLeft className="h-4 w-4" />
          {backLabel}
        </Button>
      )}
      
      {title && (
        <div>
          <h1 className="text-3xl font-bold">{title}</h1>
          {subtitle && <p className="text-muted-foreground mt-1">{subtitle}</p>}
        </div>
      )}
      
      {children}
    </div>
  );
};

export default HeaderWithBackButton;
